type TFiltersUrlSetter = (filtersUrl: string) => void;

let filtersUrlSetter: TFiltersUrlSetter | null = null;

export function registerFiltersUrlSetter(setter: TFiltersUrlSetter): () => void {
  filtersUrlSetter = setter;

  return () => {
    if (filtersUrlSetter === setter) {
      filtersUrlSetter = null;
    }
  };
}

export function setFiltersUrl(filtersUrl: string): void {
  filtersUrlSetter?.(filtersUrl);
}
